import React, { Component } from 'react'
import { Nav } from 'reactstrap'
import PropTypes from 'prop-types'
import AdminNavBarItem from '../AdminNavBarItem'

export default class AdminNavBar extends Component {
  static propTypes = {
    isCssAdmin: PropTypes.bool.isRequired,
    isOperationsAdmin: PropTypes.bool.isRequired,
    isTechnologyAdmin: PropTypes.bool.isRequired,
  }

  getNavLinks() {
    const { isCssAdmin, isOperationsAdmin, isTechnologyAdmin } = this.props

    const links = []

    if (isCssAdmin || isOperationsAdmin || isTechnologyAdmin) {
      links.push({
        id: 'css-admin',
        name: 'CSS Admin',
        endpoint: '/css-admin',
      })
    }

    return links
  }

  render = () => {
    return (
      <Nav fill justified pills style={{ marginBottom: '2rem' }}>
        {this.getNavLinks().map(link => (
          <AdminNavBarItem key={link.id} {...link} />
        ))}
      </Nav>
    )
  }
}
